module.exports = __webpack_public_path__ + "images/stickers/taco-confused@2x.06668f130b632bf4ba0d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/taco-confused@2x.png
// module id = mHRC
// module chunks = 1